import { render, staticRenderFns } from "./ManageWhitelist.vue?vue&type=template&id=2acac530&"
import script from "./ManageWhitelist.vue?vue&type=script&lang=js&"
export * from "./ManageWhitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports